import RevisedBanner from "./RevisedBanner";
export default RevisedBanner;
